<template>
  <form>
    <div class="row">
      <!--<div class="col-lg-12">
        <base-alert type="warning" dismissible>
          {{$t('medium_grant.technical__1_editable_version')}}
          <div class="mt-2">
            <a :href="downloadFiles[$i18n.locale]" class="link-download-white" target="_blank">{{$t('medium_grant.technical__1_editable_version_download')}}
              <img class="ml-2" width="25" src="/img/icons/doc-white.png"> </a>
          </div>
        </base-alert>
      </div>-->
    </div>
    <div class="row mt-3">
      <div class="col-lg-4">
        <h4 class="card-title">{{$t('medium_grant.technical__1_overview')}}</h4>
        <div class="form-group">
          <label>{{$t('medium_grant.technical__1_title_of_project')}}</label>
          <textarea
            class="form-control"
            name="cndescription.titleOfProject"
            v-model="GrantForm.title"
            :error="getError('cndescription.titleOfProject')"
            v-validate="'required'"
            :data-vv-as="$t('medium_grant.technical__1_title_of_project')"
            :label="$t('medium_grant.technical__1_title_of_project')"
            :placeholder="$t('medium_grant.technical__1_title_of_project')"
            :disabled="GrantForm.disableConcept"
          >
          </textarea>
        </div>
        <div class="form-group">
          <label for="regionSelect">{{$t('medium_grant.technical__1_region')}}</label> <select class="form-control"
                                                                                              disabled
                                                                                               @change="setRegion"
                                                                                               name="technical.region"
                                                                                               id="regionSelect"
                                                                                               :error="getError('cndescription.region')"
                                                                                               v-validate="'required'"
                                                                                               :data-vv-as="$t('medium_grant.technical__1_region')"
        >
          <option value="" selected="selected">{{$t('medium_grant.general__please_select')}}</option>
          <option :value="region.regionId" :selected="GrantForm.regionId === region.regionId" v-for="region in regions" :key="region.regionId">{{region.code}} - {{region.name}}</option>
        </select>
          <label v-if="getError('cndescription.region')" class="error text-danger">{{getError('cndescription.region')}}</label>
        </div>
        <div class="form-group" :class="{'has-danger': getError('cndescription.acpCountry')}">
          <label for="countrySelect">{{$t('medium_grant.technical__1_acp_country')}}</label>
          <multiselect name="cndescription.acpCountry" v-model="GrantForm.model.cndescription.acpCountry" selectLabel="" selectedLabel="" deselectLabel="Clear" v-validate="'required'" :data-vv-as="$t('medium_grant.technical__1_acp_country')" :tag-placeholder="$t('medium_grant.general__please_select')" :placeholder="$t('medium_grant.general__please_select')" label="name" track-by="countryId" :options="countriesByRegion" :multiple="true" :disabled="GrantForm.disableConcept"></multiselect>
          <label v-if="getError('cndescription.acpCountry')" class="error text-danger">{{getError('cndescription.acpCountry')}}</label>
        </div>

        <div class="form-group">
          <label for="regionSelect">{{$t('medium_grant.technical__1_priority_landscape')}}</label>
          <textarea
            class="form-control"
            name="cndescription.priorityLandscape"
            v-model="GrantForm.model.cndescription.priorityLandscape"
            :error="getError('cndescription.priorityLandscape')"
            v-validate="'required'"
            :data-vv-as="$t('medium_grant.technical__1_priority_landscape')"
            :label="$t('medium_grant.technical__1_priority_landscape')"
            :placeholder="$t('medium_grant.technical__1_priority_landscape')"
            :disabled="GrantForm.disableConcept"
          >
          </textarea>
        </div>
        <div class="form-group">
          <label for="regionSelect">Registration number of the PA(s)</label>
          <textarea
            class="form-control"
            name="cndescription.paTarget"
            v-model="GrantForm.model.cndescription.paTarget"
            :error="getError('cndescription.paTarget')"
            v-validate="'required'"
            :data-vv-as="$t('medium_grant.technical__1_pa_target')"
            :label="$t('medium_grant.technical__1_pa_target')"
            :placeholder="$t('medium_grant.technical__1_pa_target')"
            :disabled="GrantForm.disableConcept"
          >
          </textarea>
        </div>
        <div class="form-group">
          <label for="regionSelect">PA(s) supervisory authority</label>
          <textarea
            class="form-control"
            name="cndescription.paSupervisory"
            v-model="GrantForm.model.cndescription.paSupervisory"
            :error="getError('cndescription.paSupervisory')"
            v-validate="'required'"
            :data-vv-as="$t('medium_grant.technical__1_pa_supervisory')"
            :label="$t('medium_grant.technical__1_pa_supervisory')"
            :placeholder="$t('medium_grant.technical__1_pa_supervisory')"
            :disabled="GrantForm.disableConcept"
          >
          </textarea>
        </div>
        <div class="mb-3">
          <!--<p>{{$t('medium_grant.technical__1_pa_supervisory_upload')}}</p>-->
          <p>{{$t('medium_grant.technical_upload_letter_support')}}</p>
          <upload-file v-if="GrantForm.initialized" v-model="GrantForm.files.technical.supervisoryUpload" :file-data="GrantForm.files.technical.supervisoryUpload" :is-editable="GrantForm.isEditable && !GrantForm.disableConcept" :size-limit="GrantForm.fileSizeLimit" section="technical.supervisoryUpload" type="cn"></upload-file>
        </div>
        <div class="form-group">
          <label for="countrySelect">{{$t('medium_grant.technical__1_name_lead_org')}}</label>
          <textarea
            class="form-control"
            name="cndescription.nameOfLeadOrg"
            v-model="GrantForm.model.cndescription.nameOfLeadOrg"
            :error="getError('cndescription.nameOfLeadOrg')"
            v-validate="'required'"
            :data-vv-as="$t('medium_grant.technical__1_name_lead_org')"
            :label="$t('medium_grant.technical__1_name_lead_org')"
            :placeholder="$t('medium_grant.technical__1_name_lead_org')"
            :disabled="GrantForm.disableConcept"
          >
          </textarea>
        </div>
        <div class="form-group">
          <label for="countrySelect">{{$t('medium_grant.technical__1_name_of_co_app')}}</label>
          <textarea
            class="form-control"
            name="cndescription.nameOfCoApplicants"
            v-model="GrantForm.model.cndescription.nameOfCoApplicants"
            :label="$t('medium_grant.technical__1_name_of_co_app')"
            :placeholder="$t('medium_grant.technical__1_name_of_co_app')"
            :disabled="GrantForm.disableConcept"
          >
          </textarea>
        </div>
        <div class="row">
          <div class="col-lg-6">
            <base-input
              name="cndescription.startDate"
              v-model="GrantForm.model.cndescription.startDate"
              :error="getError1('cndescription.startDate')"
              v-validate="'required'"
              :data-vv-as="$t('medium_grant.technical__1_startdate')"
              :placeholder="$t('medium_grant.technical__1_startdate')"
              :disabled="GrantForm.disableConcept"
            >
              <label>{{$t('medium_grant.technical__1_startdate')}}</label>
              <el-date-picker
                type="date"
                v-model="startDate"
                :placeholder="$t('medium_grant.technical__1_startdate')"
                :disabled="GrantForm.disableConcept"
              >
              </el-date-picker>
            </base-input>
          </div>
          <div class="col-lg-6">
            <base-input
              name="cndescription.endDate"
              v-model="GrantForm.model.cndescription.endDate"
              :placeholder="$t('medium_grant.technical__1_enddate')"
              :error="getError2('cndescription.endDate')"
              v-validate="'required'"
              :data-vv-as="$t('medium_grant.technical__1_enddate')"
              :disabled="GrantForm.disableConcept"
            >
              <label>{{$t('medium_grant.technical__1_enddate')}}</label>
              <el-date-picker
                type="date"
                v-model="endDate"
                :placeholder="$t('medium_grant.technical__1_enddate')"
                :disabled="GrantForm.disableConcept"
              >
              </el-date-picker>
            </base-input>
          </div>
        </div>
        <div class="form-group">
          <label for="countrySelect">{{$t('medium_grant.technical__1_duration')}}(in months)</label>
          <textarea
            class="form-control"
            name="cndescription.duration"
            v-model="GrantForm.model.cndescription.duration"
            :error="getError('cndescription.duration')"
            v-validate="'required'"
            :data-vv-as="$t('medium_grant.technical__1_duration')"
            :label="$t('medium_grant.technical__1_duration')"
            :placeholder="$t('medium_grant.technical__1_duration')"
            :disabled="GrantForm.disableConcept"
          >
          </textarea>
        </div>
        <div class="form-group">
          <label for="countrySelect">{{$t('medium_grant.technical__1_total_budget')}}(in EUR)</label>
          <textarea
            class="form-control"
            name="cndescription.totalBudget"
            v-model="GrantForm.model.cndescription.totalBudget"
            :error="getError('cndescription.totalBudget')"
            v-validate="'required'"
            :data-vv-as="$t('medium_grant.technical__1_total_budget')"
            :label="$t('medium_grant.technical__1_total_budget')"
            :placeholder="$t('medium_grant.technical__1_total_budget')"
            :disabled="GrantForm.disableConcept"
          >
          </textarea>
        </div>
        <div class="form-group">
          <label for="countrySelect">{{$t('medium_grant.technical__1_total_funding')}}(in EUR)</label>
          <textarea
            class="form-control"
            name="cndescription.totalFunding"
            v-model="GrantForm.model.cndescription.totalFunding"
            :error="getError('cndescription.totalFunding')"
            v-validate="'required'"
            :data-vv-as="$t('medium_grant.technical__1_total_funding')"
            :label="$t('medium_grant.technical__1_total_funding')"
            :placeholder="$t('medium_grant.technical__1_total_funding')"
            :disabled="GrantForm.disableConcept"
          >
          </textarea>
        </div>
        <div class="form-group">
          <!--<label for="countrySelect" v-if="GrantForm.regionId == 5 || GrantForm.regionId == 6">{{$t('medium_grant_cn.total_funding_requested')}}</label>-->
          <!--<label for="countrySelect" v-else>{{$t('medium_grant.technical__1_total_cofunding')}}(in EUR)</label>-->
          <label for="countrySelect">{{$t('medium_grant_cn.total_funding_requested')}}</label>
          <textarea
            class="form-control"
            name="cndescription.totalCoFunding"
            v-model="GrantForm.model.cndescription.totalCoFunding"
            :error="getError('cndescription.totalCoFunding')"
            v-validate="'required'"
            :data-vv-as="$t('medium_grant.technical__1_total_cofunding')"
            :label="$t('medium_grant.technical__1_total_cofunding')"
            :placeholder="$t('medium_grant_cn.total_funding_requested')"
            :disabled="GrantForm.disableConcept"
          >
          </textarea>
          <!--v-on:change="totalCoFunding(GrantForm.model.cndescription.totalCoFunding)"-->
        </div>
      </div>
      <div class="col-lg-4">
        <h6>
          {{$t('medium_grant.technical__1_biopama_action')}}
        </h6>
        <div class="mt-4"></div>
        <base-checkbox name="checkbox" v-model="GrantForm.model.cndescription.enhaceManagement" :disabled="GrantForm.disableConcept">
          {{$t('medium_grant.technical__1_enhace_management')}}
        </base-checkbox>
        <base-checkbox name="checkbox" v-model="GrantForm.model.cndescription.enforceLegal" :disabled="GrantForm.disableConcept">
          {{$t('medium_grant.technical__1_enforce_legal')}}
        </base-checkbox>
        <base-checkbox name="checkbox" v-model="GrantForm.model.cndescription.supportLocal" :disabled="GrantForm.disableConcept">
          {{$t('medium_grant.technical__1_support_local')}}
        </base-checkbox>
        <div class="mt-4"></div>
        <div>
          <label>{{$t('medium_grant.technical__1_priorities_for_action')}}</label>
        </div>
        <div>
          <label>{{$t('medium_grant.technical__1_priorities_for_action_sub')}}</label>
        </div>
        <textarea
          class="form-control"
          :placeholder="$t('medium_grant.technical__1_please_indicate')"
          v-model="GrantForm.model.cndescription.indicatePriorities"
          :disabled="GrantForm.disableConcept"
        >
        </textarea>
        <div class="mt-4">
          <label class="mb-3">{{$t('medium_grant.technical__1_project_enable_data_sharing')}}</label>
          <radio name="organisationType"
                 inline
                 :value="true"
                 v-model="GrantForm.model.cndescription.enableDataSharing"
                 :disabled="GrantForm.disableConcept"
          >
            {{$t('medium_grant.technical__1_project_enable_data_sharing_yes')}}
          </radio>
          <radio name="organisationType" inline :value="false" v-model="GrantForm.model.cndescription.enableDataSharing" :disabled="GrantForm.disableConcept">
            {{$t('medium_grant.technical__1_project_enable_data_sharing_no')}}
          </radio>
        </div>
        <div class="mt-4"></div>
               <h6>
          {{$t('medium_grant.technical__1_reference_doc')}}
        </h6>
        <div class="mt-4"></div>
        <base-checkbox name="checkbox" v-model="GrantForm.model.cndescription.managementGov" :disabled="GrantForm.disableConcept">
          {{$t('medium_grant_cn.technical__1_quantified_management')}}
        </base-checkbox>
        <base-checkbox name="checkbox" v-model="GrantForm.model.cndescription.strategicDoc" :disabled="GrantForm.disableConcept">
          {{$t('medium_grant_cn.technical__1_quantified_governance')}}
        </base-checkbox>
        <!--<div class="mb-3">
          <textarea class="form-control" :placeholder="'Upload diagnostic tool file'" :file-data="GrantForm.files.technical.supervisoryUpload" :is-editable="GrantForm.isEditable" :size-limit="GrantForm.fileSizeLimit" section="technical.supervisoryUpload">

          </textarea>
        </div>-->
        <div class="mt-2"></div>
        <p>Upload diagnostic tool file</p>
          <upload-file v-if="GrantForm.initialized" v-model="GrantForm.files.technical.diagnosticToolDoc" :is-editable="GrantForm.isEditable && !GrantForm.disableConcept" :file-data="GrantForm.files.technical.diagnosticToolDoc" :size-limit="GrantForm.fileSizeLimit" section="technical.diagnosticToolDoc" type="cn"></upload-file>
      </div>
      
      <div class="col-lg-4">
        <h4 class="card-title">{{ $t('monitoring.field_title_keyword_for_better_identifying_your_project') }}</h4>
        <div class="mt-4"></div>
        <h5 class="card-subtitle">{{ $t('monitoring.field_subtitle_type_of_priority_area') }}</h5>
        <div class="form-group">
            <base-checkbox
                name="checkbox"
                v-model="GrantForm.model.cndescription.typeOfPriorityKeywordMarineProtectedConservedArea"
                :disabled="GrantForm.disableConcept"
                >
                {{ $t('monitoring.field_type_of_priority_keyword_marine_protected_conserved_area') }}
            </base-checkbox>
            <base-checkbox
                name="checkbox"
                v-model="GrantForm.model.cndescription.typeOfPriorityKeywordMarineManagedAreas"
                :disabled="GrantForm.disableConcept"
                >
                {{ $t('monitoring.field_type_of_priority_keyword_marine_managed_areas') }}
            </base-checkbox>
            <base-checkbox
                name="checkbox"
                v-model="GrantForm.model.cndescription.typeOfPriorityKeywordTerrestrialProtectedConservedArea"
                :disabled="GrantForm.disableConcept"
                >
                {{ $t('monitoring.field_type_of_priority_keyword_terrestrial_protected_conserved_area') }}
            </base-checkbox>
            <base-checkbox
                name="checkbox"
                v-model="GrantForm.model.cndescription.typeOfPriorityKeywordIndigenousAndCommunityConservedArea"
                :disabled="GrantForm.disableConcept"
                >
                {{ $t('monitoring.field_type_of_priority_keyword_indigenous_and_community_conserved_area') }}
            </base-checkbox>
            <base-checkbox
                name="checkbox"
                v-model="GrantForm.model.cndescription.typeOfPriorityKeywordPrivatelyProtectedArea"
                :disabled="GrantForm.disableConcept"
                >
                {{ $t('monitoring.field_type_of_priority_keyword_privately_protected_area') }}
            </base-checkbox>
            <base-checkbox
                name="checkbox"
                v-model="GrantForm.model.cndescription.typeOfPriorityKeywordConservancy"
                :disabled="GrantForm.disableConcept"
                >
                {{ $t('monitoring.field_type_of_priority_keyword_conservancy') }}
            </base-checkbox>
            <base-checkbox
                name="checkbox"
                v-model="GrantForm.model.cndescription.typeOfPriorityKeywordKeyLandscapeForConservation"
                :disabled="GrantForm.disableConcept"
                >
                {{ $t('monitoring.field_type_of_priority_keyword_key_landscape_for_conservation') }}
            </base-checkbox>
            <base-checkbox
                name="checkbox"
                v-model="GrantForm.model.cndescription.typeOfPriorityKeywordKbas"
                :disabled="GrantForm.disableConcept"
                >
                {{ $t('monitoring.field_type_of_priority_keyword_KBAs') }}
            </base-checkbox>
            <base-checkbox
                name="checkbox"
                v-model="GrantForm.model.cndescription.typeOfPriorityKeywordTransboundaryAreas"
                :disabled="GrantForm.disableConcept"
                >
                {{ $t('monitoring.field_type_of_priority_keyword_transboundary_areas') }}
            </base-checkbox>
        </div>
  <div class="mt-4"></div>
        <h5 class="card-subtitle">{{ $t('monitoring.field_subtitle_primary_objective') }}</h5>
        <div class="form-group">
            <radio name="model.frequency"
                value="governance"
                v-model="GrantForm.model.cndescription.keywordPrimaryObjective"
                :disabled="GrantForm.disableConcept"
                >
                <label>{{ $t('monitoring.field_primary_objective_keyword_governance') }}</label>
            </radio>
            <radio name="model.frequency"
                value="management_effectiveness"
                v-model="GrantForm.model.cndescription.keywordPrimaryObjective"
                :disabled="GrantForm.disableConcept"
                >
                <label>{{ $t('monitoring.field_primary_objective_keyword_management_effectiveness') }}</label>
            </radio>
            <radio name="model.frequency"
                value="livelihoods"
                v-model="GrantForm.model.cndescription.keywordPrimaryObjective"
                :disabled="GrantForm.disableConcept"
                >
                <label>{{ $t('monitoring.field_primary_objective_keyword_livelihoods') }}</label>
            </radio>
        </div>
        <div class="mt-4"></div>
        <h5 class="card-subtitle">{{ $t('monitoring.field_subtitle_target_groups') }}</h5>
        <div class="form-group">
            <base-checkbox
                name="checkbox"
                v-model="GrantForm.model.cndescription.targetGroupsKeywordLocalCommunities"
                :disabled="GrantForm.disableConcept"
                >
                {{ $t('monitoring.field_target_groups_keyword_local_communities') }}
            </base-checkbox>
            <base-checkbox
                name="checkbox"
                v-model="GrantForm.model.cndescription.targetGroupsKeywordIndigenousPpeople"
                :disabled="GrantForm.disableConcept"
                >
                {{ $t('monitoring.field_target_groups_keyword_indigenous_people') }}
            </base-checkbox>
            <base-checkbox
                name="checkbox"
                v-model="GrantForm.model.cndescription.targetGroupsKeywordYouth"
                :disabled="GrantForm.disableConcept"
                >
                {{ $t('monitoring.field_target_groups_keyword_youth') }}
            </base-checkbox>
            <base-checkbox
                name="checkbox"
                v-model="GrantForm.model.cndescription.targetGroupsKeywordWomen"
                :disabled="GrantForm.disableConcept"
                >
                {{ $t('monitoring.field_target_groups_keyword_women') }}
            </base-checkbox>
            <base-checkbox
                name="checkbox"
                v-model="GrantForm.model.cndescription.targetGroupsKeywordPrivateSector"
                :disabled="GrantForm.disableConcept"
                >
                {{ $t('monitoring.field_target_groups_keyword_private_sector') }}
            </base-checkbox>
            <base-checkbox
                name="checkbox"
                v-model="GrantForm.model.cndescription.targetGroupsKeywordFarmersFishermen"
                :disabled="GrantForm.disableConcept"
                >
                {{ $t('monitoring.field_target_groups_keyword_farmers_fishermen') }}
            </base-checkbox>
            <base-checkbox
                name="checkbox"
                v-model="GrantForm.model.cndescription.targetGroupsKeywordNationalLocalPaAgency"
                :disabled="GrantForm.disableConcept"
                >
                {{ $t('monitoring.field_target_groups_keyword_national_local_pa_agency') }}
            </base-checkbox>
            <base-checkbox
                name="checkbox"
                v-model="GrantForm.model.cndescription.targetGroupsKeywordNationalGovernment"
                :disabled="GrantForm.disableConcept"
                >
                {{ $t('monitoring.field_target_groups_keyword_national_government') }}
            </base-checkbox>
            <base-checkbox
                name="checkbox"
                v-model="GrantForm.model.cndescription.targetGroupsKeywordSubnationalGovernments"
                :disabled="GrantForm.disableConcept"
                >
                {{ $t('monitoring.field_target_groups_keyword_subnational_governments') }}
            </base-checkbox>
        </div>
        <div class="mt-4"></div>
        <h5 class="card-subtitle">{{ $t('monitoring.field_subtitle_main_activity_focus') }}</h5>
        <div class="form-group row">
            <div class="col-6">
                <base-checkbox
                    name="checkbox"
                    v-model="GrantForm.model.cndescription.fieldMainActivityFocusKeywordManagementPlan"
                    :disabled="GrantForm.disableConcept"
                    >
                    {{ $t('monitoring.field_main_activity_focus_keyword_management_plan') }}
                </base-checkbox>
                <base-checkbox
                    name="checkbox"
                    v-model="GrantForm.model.cndescription.fieldMainActivityFocusKeywordEnforcement"
                    :disabled="GrantForm.disableConcept"
                    >
                    {{ $t('monitoring.field_main_activity_focus_keyword_enforcement') }}
                </base-checkbox>
                <base-checkbox
                    name="checkbox"
                    v-model="GrantForm.model.cndescription.fieldMainActivityFocusKeywordLegalFrameworkRegulation"
                    :disabled="GrantForm.disableConcept"
                    >
                    {{ $t('monitoring.field_main_activity_focus_keyword_legal_framework_regulation') }}
                </base-checkbox>
                <base-checkbox
                    name="checkbox"
                    v-model="GrantForm.model.cndescription.fieldMainActivityFocusKeywordIllegalActivities"
                    :disabled="GrantForm.disableConcept"
                    >
                    {{ $t('monitoring.field_main_activity_focus_keyword_illegal_activities') }}
                </base-checkbox>
                <base-checkbox
                    name="checkbox"
                    v-model="GrantForm.model.cndescription.fieldMainActivityFocusKeywordCoManagement"
                    :disabled="GrantForm.disableConcept"
                    >
                    {{ $t('monitoring.field_main_activity_focus_keyword_co_management') }}
                </base-checkbox>
                <base-checkbox
                    name="checkbox"
                    v-model="GrantForm.model.cndescription.fieldMainActivityFocusKeywordParticipation"
                    :disabled="GrantForm.disableConcept"
                    >
                    {{ $t('monitoring.field_main_activity_focus_keyword_participation') }}
                </base-checkbox>
                <base-checkbox
                    name="checkbox"
                    v-model="GrantForm.model.cndescription.fieldMainActivityFocusKeywordLivelihoodsAlternativeEconomicActivities"
                    :disabled="GrantForm.disableConcept"
                    >
                    {{ $t('monitoring.field_main_activity_focus_keyword_livelihoods_alternative_economic_activities') }}
                </base-checkbox>
                <base-checkbox
                    name="checkbox"
                    v-model="GrantForm.model.cndescription.fieldMainActivityFocusKeywordSustainableDevelopment"
                    :disabled="GrantForm.disableConcept"
                    >
                    {{ $t('monitoring.field_main_activity_focus_keyword_sustainable_development') }}
                </base-checkbox>
                <base-checkbox
                    name="checkbox"
                    v-model="GrantForm.model.cndescription.fieldMainActivityFocusKeywordLandscapeApproach"
                    :disabled="GrantForm.disableConcept"
                    >
                    {{ $t('monitoring.field_main_activity_focus_keyword_landscape_approach') }}
                </base-checkbox>
                <base-checkbox
                    name="checkbox"
                    v-model="GrantForm.model.cndescription.fieldMainActivityFocusKeywordEcoTourism"
                    :disabled="GrantForm.disableConcept"
                    >
                    {{ $t('monitoring.field_main_activity_focus_keyword_eco_tourism') }}
                </base-checkbox>
                <base-checkbox
                    name="checkbox"
                    v-model="GrantForm.model.cndescription.fieldMainActivityFocusKeywordSustainableFinancing"
                    :disabled="GrantForm.disableConcept"
                    >
                    {{ $t('monitoring.field_main_activity_focus_keyword_sustainable_financing') }}
                </base-checkbox>
                <base-checkbox
                    name="checkbox"
                    v-model="GrantForm.model.cndescription.fieldMainActivityFocusKeywordThreatenedSpecies"
                    :disabled="GrantForm.disableConcept"
                    >
                    {{ $t('monitoring.field_main_activity_focus_keyword_threatened_species') }}
                </base-checkbox>
            </div>
<div class="mt-4"></div>
            <div class="col-6">
                <base-checkbox
                    name="checkbox"
                    v-model="GrantForm.model.cndescription.fieldMainActivityFocusKeywordHumanWildlifeConflict"
                    :disabled="GrantForm.disableConcept"
                    >
                    {{ $t('monitoring.field_main_activity_focus_keyword_human_wildlife_conflict') }}
                </base-checkbox>
                <base-checkbox
                    name="checkbox"
                    v-model="GrantForm.model.cndescription.fieldMainActivityFocusKeywordEcosystemHabitatRestoration"
                    :disabled="GrantForm.disableConcept"
                    >
                    {{ $t('monitoring.field_main_activity_focus_keyword_ecosystem_habitat_restoration') }}
                </base-checkbox>
                <base-checkbox
                    name="checkbox"
                    v-model="GrantForm.model.cndescription.fieldMainActivityFocusKeywordInvasiveAlienSpecies"
                    :disabled="GrantForm.disableConcept"
                    >
                    {{ $t('monitoring.field_main_activity_focus_keyword_invasive_alien_species') }}
                </base-checkbox>
                <base-checkbox
                    name="checkbox"
                    v-model="GrantForm.model.cndescription.fieldMainActivityFocusKeywordSurveyDataKnowledgeManagement"
                    :disabled="GrantForm.disableConcept"
                    >
                    {{ $t('monitoring.field_main_activity_focus_keyword_survey_data_knowledge_management') }}
                </base-checkbox>
                <base-checkbox
                    name="checkbox"
                    v-model="GrantForm.model.cndescription.fieldMainActivityFocusKeywordProtectedAreaManagementEffectivenessPame"
                    :disabled="GrantForm.disableConcept"
                    >
                    {{ $t('monitoring.field_main_activity_focus_keyword_protected_area_management_effectiveness_pame') }}
                </base-checkbox>
                <base-checkbox
                    name="checkbox"
                    v-model="GrantForm.model.cndescription.fieldMainActivityFocusKeywordProtectedAreaGovernanceEffectivenessPage"
                    :disabled="GrantForm.disableConcept"
                    >
                    {{ $t('monitoring.field_main_activity_focus_keyword_protected_area_governance_effectiveness_page') }}
                </base-checkbox>
                <base-checkbox
                    name="checkbox"
                    v-model="GrantForm.model.cndescription.fieldMainActivityFocusKeywordCapacityBuilding"
                    :disabled="GrantForm.disableConcept"
                    >
                    {{ $t('monitoring.field_main_activity_focus_keyword_capacity_building') }}
                </base-checkbox>
                <base-checkbox
                    name="checkbox"
                    v-model="GrantForm.model.cndescription.fieldMainActivityFocusKeywordAwarenessEducation"
                    :disabled="GrantForm.disableConcept"
                    >
                    {{ $t('monitoring.field_main_activity_focus_keyword_awareness_education') }}
                </base-checkbox>
                <base-checkbox
                    name="checkbox"
                    v-model="GrantForm.model.cndescription.fieldMainActivityFocusKeywordClimateAdaptationMitigationResilience"
                    :disabled="GrantForm.disableConcept"
                    >
                    {{ $t('monitoring.field_main_activity_focus_keyword_climate_adaptation_mitigation_resilience') }}
                </base-checkbox>
                <base-checkbox
                    name="checkbox"
                    v-model="GrantForm.model.cndescription.fieldMainActivityFocusKeywordMnitoringPatrolEquipment"
                    :disabled="GrantForm.disableConcept"
                    >
                    {{ $t('monitoring.field_main_activity_focus_keyword_monitoring_patrol_equipment') }}
                </base-checkbox>
                <base-checkbox
                    name="checkbox"
                    v-model="GrantForm.model.cndescription.fieldMainActivityFocusKeywordHumanRights"
                    :disabled="GrantForm.disableConcept"
                    >
                    {{ $t('monitoring.field_main_activity_focus_keyword_human_rights') }}
                </base-checkbox>
                <base-checkbox
                    name="checkbox"
                    v-model="GrantForm.model.cndescription.fieldMainActivityFocusKeywordGreenList"
                    :disabled="GrantForm.disableConcept"
                    >
                    {{ $t('monitoring.field_main_activity_focus_keyword_green_list') }}
                </base-checkbox>
            </div>
        </div>
<div class="mt-4"></div>
        <h4 class="card-title">{{ $t('monitoring.field_title_support_to_local_communities') }}</h4>
        <div class="form-group">
            <base-checkbox
                name="checkbox"
                v-model="GrantForm.model.cndescription.supportKeywordA"
                :disabled="GrantForm.disableConcept"
                >
                {{ $t('monitoring.field_support_keyword_01') }}
            </base-checkbox>
            <base-checkbox
                name="checkbox"
                v-model="GrantForm.model.cndescription.supportKeywordB"
                :disabled="GrantForm.disableConcept"
                >
                {{ $t('monitoring.field_support_keyword_02') }}
            </base-checkbox>
            <base-checkbox
                name="checkbox"
                v-model="GrantForm.model.cndescription.supportKeywordC"
                :disabled="GrantForm.disableConcept"
                >
                {{ $t('monitoring.field_support_keyword_03') }}
            </base-checkbox>
            <base-checkbox
                name="checkbox"
                v-model="GrantForm.model.cndescription.supportKeywordD"
                :disabled="GrantForm.disableConcept"
                >
                {{ $t('monitoring.field_support_keyword_04') }}
            </base-checkbox>
            <base-checkbox
                name="checkbox"
                v-model="GrantForm.model.cndescription.supportKeywordE"
                :disabled="GrantForm.disableConcept"
                >
                {{ $t('monitoring.field_support_keyword_05') }}
            </base-checkbox>
            <base-checkbox
                name="checkbox"
                v-model="GrantForm.model.cndescription.supportKeywordF"
                :disabled="GrantForm.disableConcept"
                >
                {{ $t('monitoring.field_support_keyword_06') }}
            </base-checkbox>
            <base-checkbox
                name="checkbox"
                v-model="GrantForm.model.cndescription.supportKeywordG"
                :disabled="GrantForm.disableConcept"
                >
                {{ $t('monitoring.field_support_keyword_07') }}
            </base-checkbox>
            <base-checkbox
                name="checkbox"
                v-model="GrantForm.model.cndescription.supportKeywordH"
                :disabled="GrantForm.disableConcept"
                >
                {{ $t('monitoring.field_support_keyword_08') }}
            </base-checkbox>
            <base-checkbox
                name="checkbox"
                v-model="GrantForm.model.cndescription.supportKeywordI"
                :disabled="GrantForm.disableConcept"
                >
                {{ $t('monitoring.field_support_keyword_09') }}
            </base-checkbox>
            <base-checkbox
                name="checkbox"
                v-model="GrantForm.model.cndescription.supportKeywordJ"
                :disabled="GrantForm.disableConcept"
                >
                {{ $t('monitoring.field_support_keyword_10') }}
            </base-checkbox>
            <base-checkbox
                name="checkbox"
                v-model="GrantForm.model.cndescription.supportKeywordK"
                :disabled="GrantForm.disableConcept"
                >
                {{ $t('monitoring.field_support_keyword_11') }}
            </base-checkbox>
            <base-checkbox
                name="checkbox"
                v-model="GrantForm.model.cndescription.supportKeywordL"
                :disabled="GrantForm.disableConcept"
                >
                {{ $t('monitoring.field_support_keyword_12') }}
            </base-checkbox>
            <base-checkbox
                name="checkbox"
                v-model="GrantForm.model.cndescription.supportKeywordM"
                :disabled="GrantForm.disableConcept"
                >
                {{ $t('monitoring.field_support_keyword_13') }}
            </base-checkbox>
            <base-checkbox
                name="checkbox"
                v-model="GrantForm.model.cndescription.supportKeywordN"
                :disabled="GrantForm.disableConcept"
                >
                {{ $t('monitoring.field_support_keyword_14') }}
            </base-checkbox>
        </div>
      </div>
      
    </div>
  </form>
</template>
<script>
  import {DatePicker} from 'element-ui';
  import Multiselect from 'vue-multiselect';
  import {GrantForm, RegionService} from "@/services";
  import {BaseAlert} from 'src/components';

  export default {
    components: {
      [DatePicker.name]: DatePicker,
      Multiselect,
      BaseAlert
    },
    data() {
      return {
        GrantForm,
        startDate: '',
        endDate: '',
        moment: '',
        regions: [],
        options: [],
        value: [],
        downloadFiles: {
          en: '/files/en/Application_template_BIOPAMA_medium_grants_2019_EN.docx',
          fr: '/files/fr/Application_template_BIOPAMA_medium_grants_2019_FR.docx'
        },
        /*pickerOptions: {
          disabledDate: this.disabledDate,
          onPick: this.pick
        }*/
      }
    },
    computed: {
      countriesByRegion() {
        let countries = [];
        let region = this.regions.filter((region) => {
          return region.regionId === GrantForm.regionId;
        })
        if (region[0] !== undefined && region[0].countries !== undefined && region[0].countries.length) {
          countries = region[0].countries;
        }
        return countries;
      }
    },
    async beforeMount() {
      this.moment = require('moment');

      let loader = this.$loading.show();
      let vm = this;
      RegionService.getApplicationRegionsWithCountries().then(function (response) {
        vm.regions = response.data;

        loader.hide();
      })

      if (GrantForm.model.cndescription.startDate !== undefined) {
        this.startDate = GrantForm.model.cndescription.startDate;
      }

      if (GrantForm.model.cndescription.endDate !== undefined) {
        this.endDate = GrantForm.model.cndescription.endDate;
      }
    },
    methods: {
      totalCoFunding(newValue){
        if(GrantForm.regionId == 5 || GrantForm.regionId == 6){
          var allowedPercentage = 100;
          var maxAmount = 200000;
        }
        else if(GrantForm.regionId == 3 || GrantForm.regionId == 4){
          var allowedPercentage = 95;
          var maxAmount = 200000;
        }
        else if(GrantForm.regionId == 1){
          var allowedPercentage = 95;
          var maxAmount = 400000;
        }
        GrantForm.model.cndescription.totalCoFunding = (newValue <= (GrantForm.model.cndescription.totalFunding*allowedPercentage)/100) && (newValue <= maxAmount) ? newValue : null;
        
        //GrantForm.model.cndescription.totalCoFunding = newValue <= (GrantForm.model.cndescription.totalFunding*GrantForm.budgetPercentage)/100 ? newValue : null;
      },
    /*disabledDate(date) {
       if (this.startDate) {
         return this.startDate > date
       }
       return false;
     },*/
      getError(fieldName) {
        return this.errors.first(fieldName);
      },
      getError2(field)
            {
                if(this.errors.first(field)){
                    return 'End Date should be greater than Start Date';
                }
                else{
                    return this.errors.first(field);
                }
                
            },
      getError1(field)
            {
                if(this.errors.first(field)){
                    return 'Start Date cannot be a past date';
                }
                else{
                    return this.errors.first(field);
                }
                
            },
      getError3(field)
            {
                if(this.errors.first(field)){
                    return 'Amount cannot exceed 400000 EUR';
                }
                else{
                    return this.errors.first(field);
                }
                
            },
      validate() {
        return this.$validator.validateAll().then(res => {
          this.$emit('on-validated', res, this.model);
          return res;
        });
      },
      setRegion(event) {
        GrantForm.regionId = parseInt(event.target.value);
        GrantForm.model.cndescription.acpCountry = [];
      }
    },
    watch: {
      startDate(newValue, oldValue) {
        //GrantForm.model.cndescription.startDate = this.moment(newValue).format('YYYY-MM-DD');
        const date = this.moment(newValue).format('YYYY-MM-DD');
        const currentDate = this.moment(new Date()).format('YYYY-MM-DD');
        if(!GrantForm.isRevisionEditable)
        {
                GrantForm.model.cndescription.startDate = (date === 'Invalid date') ? null : (date >= currentDate ? date : null);
        }
        else
        {
          GrantForm.model.cndescription.startDate =date;
        }
      },
      endDate(newValue, oldValue) {
        //GrantForm.model.cndescription.endDate = this.moment(newValue).format('YYYY-MM-DD');

        const date = this.moment(newValue).format('YYYY-MM-DD');
        if(!GrantForm.isRevisionEditable)
        {
                GrantForm.model.cndescription.endDate = (date === 'Invalid date') ? null : (date > GrantForm.model.cndescription.startDate ? date : null);
        }
        else
        {
          GrantForm.model.cndescription.endDate =date;
        }
      },
      

    }
  }
</script>
<style lang="scss" scoped>
  a {
    color: black;

    &:hover {
      text-decoration: underline;
    }
  }
</style>
